// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * The parts of a template the engine writes.
 */
export enum Fill {
  Active = 1,
  Value = 2,
  Position = 4,
}
